<template>
    <footer class=" bg-[#0f172a] border-t border-slate-800 py-10 text-center text-gray-400">
      © 2026 OILLEAD SERVICES. All rights reserved.
    </footer>
</template>
